import { PromoAnalyticsService } from '@analytics/feature';
import { AsyncPipe, I18nPluralPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseStoreShopsFacade } from '@city/data-access';
import { BannerNumberShopItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { InViewportDirective, SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { SdvorButtonComponent, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2/models';
import { combineLatest, filter, map, Observable } from 'rxjs';

@Component({
  selector: 'sd-banner-number-shop',
  imports: [
    AsyncPipe,
    SdvorButtonComponent,
    SdvorIconComponent,
    NgOptimizedImage,
    SdvorGenericLinkComponent,
    InViewportDirective,
  ],
  templateUrl: './banner-number-shop.component.html',
  styleUrls: ['./banner-number-shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerNumberShopComponent implements OnInit {
  isTabletUp$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktopUp$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  bannerNumberShop$: Observable<BannerNumberShopItem>;
  countShopTitle$: Observable<string>;

  iconTypes = IconTypes;

  constructor(
    private deviceService: DeviceService,
    private promoService: PromoService,
    private baseStoreShopsFacade: BaseStoreShopsFacade,
    private i18n: I18nPluralPipe,
    private promoAnalyticsService: PromoAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.countShopTitle$ = this.baseStoreShopsFacade.activeBaseStoreShops$.pipe(
      map((shops) => {
        const count = shops.length;
        const title = this.i18n.transform(count, { one: 'магазин', few: 'магазина', many: 'магазинов' });

        return `${count} ${title}`;
      }),
    );

    this.bannerNumberShop$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTabletUp: this.isTabletUp$,
      isDesktopUp: this.isDesktopUp$,
    }).pipe(
      map(({ promo, isTabletUp, isDesktopUp }) => {
        if (promo.bannerNumberShop) {
          const { url } = promo.bannerNumberShop;

          return {
            ...promo.bannerNumberShop,
            url: isDesktopUp ? url.isDesktop : isTabletUp ? url.isTablet : url.isMobile,
          };
        }

        return {} as BannerNumberShopItem;
      }),
    );
  }

  protected onClickBanner(banner: BannerNumberShopItem): void {
    const { id, name } = banner;
    this.promoAnalyticsService.onClickBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }

  protected onBannerIntersect(banner: BannerNumberShopItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onShowBanner({
      id,
      name,
      position: 'main_page',
    });
  }
}
